import React from 'react';
import styles from './Button.module.css';

export type ButtonBaseProps = {
  disabled?: boolean;
  title: string | React.ReactNode;
  onClick?: () => void;
  loading?: boolean;
  className?: string;
};

export default function ButtonBase({title, onClick, disabled = false, loading, className}: ButtonBaseProps) {
  const resolveModuleClassNames = (input?: string): string => {
    if (!input) return '';
    return input
      .split(/\s+/)
      .filter(Boolean)
      .map(token => {
        // Map old kebab-case names to new camelCase names
        const camelCaseMap: Record<string, string> = {
          'rise-btn-compact': 'riseBtnCompact',
          'rise-btn-large': 'riseBtnLarge',
        };
        const mappedToken = camelCaseMap[token] || token;
        const mapped = (styles as Record<string, string>)[mappedToken];
        return mapped ? `${mapped} ${token}` : token;
      })
      .join(' ');
  };

  const mergedClassName = `${styles.riseBtnBase} rise-btn-base ${resolveModuleClassNames(className)}`.trim();

  return (
    <button className={mergedClassName} onClick={onClick} disabled={disabled || loading}>
      {loading ? <div className={styles.spinner} /> : title}
    </button>
  );
}
